import requester from "../../library/Requester"; 

import { secureFetchBlob, secureFetchImageBlobUrl } from "../../library/secureFetch"; 

import * as fn from '../../library/function';

import * as constants from '../../config/constants/AppConstants';

import * as util from '../../library/utilitys';

import Cookies from "js-cookie";

// import { TimeScale } from "chart.js";

const DEBUG = constants.AppSettings.DEBUG;

const ATTACH_FILE_URL = `api/master/attach_files`;

const ATTACH_FILE_CONTENT_URL = `api/master/attach_files/files`;

/** Open Input Form */
export const handleOpenInputForm = (setState, element, mode, bool, callback = null) => {
    setState((prevState) => {
        const newState = {
            ...prevState, 
            Action: {
                ...prevState.Action,
                Mode: mode,
                Alert: { 
                    mode: '', 
                    show: false
                },
                [element]: {
                    ...prevState.Action[element],
                    mode: mode,
                    show: bool
                }
            },
        };
        debuging(newState, "HANDLE-POPUP-INPUT-FORM", {element, mode, bool});
        return newState; 
    }, () => {
        if (callback && typeof callback === 'function') {
            callback(); 
        }
    });
};

/** Close Input Form */
export const handleCloseInputForm = (setState, element) => {
    setState((prevState) => {
        const newState = {
            ...prevState, 
            Action: {
                ...prevState.Action,
                Mode: '',
                Alert: { mode: '', show: false },
                [element]: {
                    ...prevState.Action[element],
                    mode: '',
                    show: false
                }
            },
            Operation: {
                ...prevState.Operation,
                Submit: false
            }
        };
        debuging(newState, "HANDLE-CLOSE-INPUT-FORM", {element});
        return newState; 
    });
};

/** Toggle Item */
export const handleToggleItem = (setState, element, item) => {
    setState((prevState) => {
        const updatedState = {
            ...prevState,
            [element]: {
                ...prevState[element],
                [item]: !prevState[element][item] 
            }
        };
        debuging(updatedState, `HANDLE-TOGGLE-ITEM`, { element, item });
        return updatedState;
    });
};

/** Input Change */
export const handleInputChange = (setState, element, e) => {
    let { name } = e.target;

    const { type, value, checked, files } = e.target;

    name = name.replace(/Inputs_|Searchs_/g, '');

    // console.log(name, type, value, checked, files);

    let Element = element.toUpperCase();

    setState((prevState) => {
        const input = prevState[element][name];
        const validator = prevState[element][name].validator;

        let newValue;
        let file = null;

        switch (type) {
            case 'radio':
                newValue = value;
                break;
            case 'checkbox':
                newValue = checked ? value : ''; 
                break;
            case 'file':
                file = files?.[0] || null;
                newValue = file ? file.name : '';
                break;
            default:
                newValue = value;
                break;
        }

        if (validator?.type === 'number' && typeof newValue === 'string') {
            newValue = newValue.replace(/,/g, '');
        
            if ((newValue.match(/\./g) || []).length > 1) {
                newValue = newValue.replace(/\.+$/, "");
            }
        }

        const updatedInputs = {
            ...prevState[element],
            [name]: {
                ...input,
                value: newValue,
                ...(type === 'file' && { file })
            }
        };

        debuging(updatedInputs, `HANDLE-${Element}-CHANGE${type === 'file' ? '-FILE' : ''}`, { element, e });

        return {
            ...prevState,
            [element]: updatedInputs
        };
    });

    if(element === 'Inputs'){
        setState((prevState) => {
            const inputs = prevState[element];
            const inputGroup = prevState?.InputGroup;
            const updatedInput = prevState[element][name];

            const validation = (type === 'checkbox') 
                ? fn.validateInput(updatedInput.validator, updatedInput.value, name, inputs, inputGroup)
                : (type === 'file')
                    ? fn.validateInput(updatedInput.validator, updatedInput.file, "", updatedInput) 
                    : fn.validateInput(updatedInput.validator, updatedInput.value);

            let updatedValidation = validation;
            if (type === 'checkbox' && validation) {
                updatedValidation = { status: false, msg: '' };
            }

            let updatedState = {
                ...prevState,
                [element]: {
                    ...prevState[element],
                    [name]: {
                        ...updatedInput,
                        error: updatedValidation
                    }
                }
            };

            if (element === 'Inputs' && updatedInput?.group) {
                const groupName = updatedInput.group;
                const groupData = inputGroup?.Checkbox?.[groupName];

                if (groupData?.validator?.type === 'checkbox' && groupData.validator.required === true) {
                    updatedState = {
                        ...updatedState,
                        InputGroup: {
                            ...prevState.InputGroup,
                            Checkbox: {
                                ...prevState.InputGroup.Checkbox,
                                [groupName]: {
                                    ...groupData,
                                    error: validation
                                }
                            }
                        }
                    };
                }
            }

            debuging(updatedState, `HANDLE-${Element}-CHANGE${type === 'file' ? '-FILE' : ''}-VALIDATION`, { element, e });

            return updatedState;
        });

        setState((prevState) => {
            const updatedState = {
                ...prevState,
                Operation: {
                    ...prevState.Operation,
                    ...(element === 'Inputs' && { Submit: fn.allInputValidatorCheck(prevState[element], prevState.InputGroup) })
                }
            };
        
            debuging(updatedState, `HANDLE-${Element}-FORM-SUBMIT`, { element, e , isValid: fn.allInputValidatorCheck(prevState[element], prevState.InputGroup) });
        
            return updatedState;
        });
    }
};

/** Discard Input Form */
export const handleDiscardInputs = (setState, element) => {
    setState((prevState) => {
        const resetInputs = Object.keys(prevState[element]).reduce((acc, key) => {
            const input = prevState[element][key];

            acc[key] = {
                ...input,
                value: '',
                error: { status: null, msg: '' },
                ...(input.type === 'file' && { file: {}, fileId: '' }) 
            };

            return acc;
        }, {});

        let resetInputGroup = { ...prevState.InputGroup };
        if (resetInputGroup?.Checkbox) {
            resetInputGroup = {
                ...resetInputGroup,
                Checkbox: Object.keys(resetInputGroup.Checkbox).reduce((acc, groupName) => {
                    acc[groupName] = {
                        ...resetInputGroup.Checkbox[groupName],
                        error: { status: null, msg: '' } 
                    };
                    return acc;
                }, {})
            };
        }

        const newState = {
            ...prevState,
            [element]: resetInputs,
            InputGroup: resetInputGroup,
            Submit: false
        };

        debuging(newState, "HANDLE-DISCARD-FORM", { element });

        setTimeout(() => {
            document.querySelectorAll('input[type="file"]').forEach(input => input.value = '');
        }, 0);

        return newState; 
    });
};

/** Reset Inline Inputs */
export const handleResetActionInline = (setState) => {
    setState((prevState) => {
        const newState = {
            ...prevState,
            Action: {
                Mode: 'new',
                OffCanvas: {
                    mode: '',
                    show: false
                },
                Inline: {
                    mode: 'new',
                    show: true
                },
                Modal: {
                    mode: '',
                    show: false
                },
                Alert: {
                    mode: '',
                    show: false
                },
                Toast: {
                    mode: '',
                    show: false
                },
                PreviewFile: {
                    show: false,
                    data: null
                },
                Loading: {
                    submit: false,
                    dataTable: false,
                    delete: false
                }
            }
        };

        debuging(newState, 'HANDLE-RESET-INLINE-INPUTS');

        return newState;
    });
};


/** Close Toast */
export const handleCloseToast = (setState) => {
    setState((prevState) => {
        const newState = {
            ...prevState, 
            Action: {
                ...prevState.Action,
                Mode: prevState.Action.Mode,
                Toast: {
                    ...prevState.Action.Toast,
                    mode: '',
                    show: false
                }
            }
        };

        debuging(newState, "HANDLE-CLOSE-TOAST");
        return newState; 
    });
};

/** Close Alert */
export const handleCloseAlert = (setState, element, e) => {
    setState((prevState) => {
        const newState = {
            ...prevState, 
            Action: {
                ...prevState.Action,
                [element]: {
                    ...prevState.Action[element],
                    mode: e.autoHide ? '' : prevState.Action[element].mode ,
                    show: !e.autoHide 
                }
            }
        };

        debuging(newState, "HANDLE-CLOSE-ALERT", {element, e});
        return newState; 
    });
};

/** Control Modal */
export const handleControlModal = (setState, e) => {
    const { mode, show, action ,id } = e;

    const section = mode === 'confirm-delete' ? 'Delete' : null;
    
    const isConfirmOperation = !!section;
  
    return new Promise((resolve) => {
        setState((prevState) => {
            const newState = {
                ...prevState,
                Action: {
                    ...prevState.Action,
                    Modal: {
                        ...prevState.Action.Modal,
                        mode: show ? mode : '',
                        show: show
                    },
                    Mode: mode,
                },
                ...(isConfirmOperation && {
                    Operation: {
                        ...prevState.Operation,
                        [section]: action
                    }
                })
            };
  
            debuging(newState, "HANDLE-MODAL", { e });
            return newState;
      }, () => {
        resolve({ section, action });
      });
    });
  };
  

  
/** Toggle Delete All */
export const handleDataTableToggleDeleteAll = (setState, e, deletes) => {
    let checked = e.target.checked;

    let deleted = [];
    if(checked){
        deletes.forEach(checkbox => { if (!deleted.includes(checkbox.value)) { deleted.push(checkbox.value); } });
    }

    setState((prevState) => {
        const newState = {
            ...prevState, 
            Deletes: {
                ...prevState.Deletes,
                checkAll: checked,
                deletes: deleted
            }
        };

        debuging(newState, "HANDLE-DATA-TABLE-CHECK-TOGGLE-DELETE-ALL", {e, deletes});
        return newState; 
    });
};

/** Toggle Delete */
export const handleDataTableToggleDelete = (setState, e) => {
    let checked = e.target.checked;
    let value = e.target.value;

    setState((prevState) => {
        let updatedDeletes = [...prevState.Deletes.deletes];

        if (checked) {
            if (!updatedDeletes.includes(value)) { updatedDeletes.push(value); }
        } else {
            updatedDeletes = updatedDeletes.filter(id => id !== value);
        }

        const allRowIds = prevState.DataTable.rows.map(row => row.id);
        const checkAll = updatedDeletes.length > 0 && updatedDeletes.length === allRowIds.length;

        const newState = {
            ...prevState,
            Deletes: {
                ...prevState.Deletes,
                checkAll: checkAll, 
                deletes: updatedDeletes
            }
        };
        
        debuging(newState, "HANDLE-DATA-TABLE-CHECK-TOGGLE-DELETE", { e, deletes: updatedDeletes });
        return newState;
    });
};


/** Pagination */
export const handleDataTablePaginationChange = (setState, { page, direction }, loadDataTable = null) => {
    setState((prevState) => {
        const { currentPage, sectionSize, totalRows, pageSize } = prevState.DataTable.pagination;
        const totalPages = Math.ceil(totalRows / pageSize);
        let newPage = page !== undefined ? page : currentPage;

        if (direction === "prev") {
            newPage = Math.max(1, Math.ceil(currentPage / sectionSize - 1) * sectionSize);
        } else if (direction === "next") {
            newPage = Math.min(totalPages, Math.ceil(currentPage / sectionSize) * sectionSize + 1);
        }

        const newState = {
            ...prevState,
            DataTable: {
                ...prevState.DataTable,
                pagination: {
                    ...prevState.DataTable.pagination,
                    currentPage: newPage
                }
            }
        };

        debuging(newState, "HANDLE-PAGINATION-UPDATE", { page, direction });
        return newState;
    }, () => {
        if (typeof loadDataTable === "function") { loadDataTable(); }
    });
};

/** Update State */
export const updateState = (updateState, key, value) => {
    if (typeof updateState === 'function') {
        updateState({ [key]: value });
    }
}

/** Navigate */
export const navigate = (navigate, route, data) => {
    navigate(route, { state: data });    
};

/** Parameter Inline */
export const parametersInline = async (updateState, key, data, debuging = () => {}) => {

    // console.log("entry parameter inline", key, data);
    return new Promise(resolve => {
        updateState(prevState => {
            
            const previousParamSection = prevState.Parameters?.[key] || {};

            const newState = {
                ...prevState,
                Action: {
                    ...prevState.Action,
                    Mode: 'new',
                    Inline: {
                        ...prevState.Action.Inline,
                        mode: 'new',
                        show: true
                    }
                },                
                Parameters: {
                    ...prevState.Parameters,
                    [key]: {
                        ...previousParamSection,
                        parameters: {
                            ...previousParamSection.parameters,
                            element: [
                                {
                                    id: data?.id || null,
                                    value: data?.value || '',
                                    label: data?.label || '',
                                    key: data?.key || '',
                                    page: data?.page || '',
                                    filters: data?.filters || [] 
                                }
                            ]
                        }
                    }
                },
                Searchs: {
                    ...prevState.Searchs,
                    ...(prevState.Searchs[data?.id] && {
                        [key]: {
                            ...prevState.Searchs[data?.id],
                            value: data?.value || ''
                        }
                    }),
                    ...(Array.isArray(data?.filters)
                    ? Object.fromEntries(
                        data.filters
                            .filter(f => f.search && prevState.Searchs?.[f.search])
                            .map(f => [
                            f.search,
                            {
                                ...prevState.Searchs[f.search],
                                value: f.value
                            }
                            ])
                        )
                    : {})                  
                },
                Inputs: {
                    ...prevState.Inputs,
                    ...(prevState.Inputs[data?.id] && {
                        [key]: {
                            ...prevState.Inputs[data?.id],
                            value: data?.value || ''
                        }
                    }),
                    ...(Array.isArray(data?.filters)
                    ? Object.fromEntries(
                        data.filters
                            .filter(f => f.input && prevState.Inputs?.[f.input])
                            .map(f => [
                            f.input,
                            {
                                ...prevState.Inputs[f.input],
                                value: f.value
                            }
                            ])
                        )
                    : {})                  
                }
            };

            // console.log("==============================debug===", newState);
            debuging(newState, "PARAMETERS-INLINE", { key, data });
            resolve();
            return newState;
        });
    });
};


/** Parameters Prompt */
export const parametersPrompt = (updateState, key, data, restore={} , callback = null) => {
    return new Promise((resolve) => {
        updateState((prevState) => {

            let updatedSearchs = { ...prevState.Searchs };

            if (Array.isArray(data.parameters?.element)) {
                data.parameters.element.forEach(({ id, value }) => {
                    if (updatedSearchs[id]) {
                        updatedSearchs[id] = { ...updatedSearchs[id], value };
                    }
                });
            }
            
            if (restore?.searchs && typeof restore.searchs === 'object') {
                Object.entries(restore.searchs).forEach(([id, item]) => {
                    const { value } = item;
            
                    if (updatedSearchs[id]) {
                        updatedSearchs[id] = {...updatedSearchs[id], value: value};
                    }
                });
            }
            
            let newState = {
                ...prevState,
                Parameters: {
                    ...prevState.Parameters,
                    [key]: { ...data },
                    restore: restore,
                },
                Searchs: updatedSearchs,
            };
            
            if (restore && typeof restore === 'object' && Object.keys(restore).length > 0) {
                newState = {
                    ...newState,
                    DataTable: {
                        ...prevState.DataTable,
                        rows: [],
                        pagination: {
                            ...prevState.DataTable.pagination,
                            currentPage: restore.currentPage || 1,
                            totalRows: 0,
                        },
                    },
                    Operation: restore.operation || prevState.Operation,
              };
            }
            
            debuging(newState, "PARAMETERS-PROMPT", { key, data });

            return newState;
        }, () => {
            if (callback) { callback(); }
            resolve(); 
        });
    });
};

/** Set Default Inputs */
export const setDefaultInputs = async (updateState, current, callback = null ) => {
    return new Promise((resolve) => {
        updateState((prevState) => {
            const { Parameters, Inputs } = prevState;

            if (!current || !Parameters[current]) {
                return prevState;
            }

            const elements = Parameters[current]?.parameters?.element || [];

            const updatedInputs = Object.keys(Inputs).reduce((acc, key) => {
                acc[key] = {
                    ...Inputs[key], 
                    value: elements.find(item => item.id === key)?.value || Inputs[key].value
                };
                return acc;
            }, {});

            elements.forEach(el => {
            if (Array.isArray(el.filters)) {
                el.filters.forEach(filter => {
                if (Inputs[filter.input]) {
                    updatedInputs[filter.input] = {
                    ...Inputs[filter.input],
                    value: filter.value
                    };
                }
                });
            }
            });            

            const newState = {
                ...prevState,
                Inputs: updatedInputs
            };

            debuging({ section: current, inputs: newState.Inputs }, "SET-DEFAULT-INPUTS");

            return newState;
        }, async () => {
            if (typeof callback === 'function') {
                await callback(); 
              }
            resolve();
        }); 
    });
};

/** Set Default Profile */
export const setProfileInputs = async (updateState, fieldMap = {}, callback = null) => {
  return new Promise((resolve) => {
    const rawProfile = Cookies.get("userProfile");
    const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

    updateState((prevState) => {
      const { Inputs } = prevState;
      const updatedInputs = { ...Inputs };

      // ถ้า fieldMap เป็น array เช่น ["enterprise_id"] → แปลงเป็น mapping ตรงตัว
      let map = Array.isArray(fieldMap)
        ? fieldMap.reduce((acc, key) => ({ ...acc, [key]: key }), {})
        : fieldMap;

      Object.entries(map).forEach(([cookieField, stateField]) => {
        if (userProfile[cookieField] !== undefined && updatedInputs[stateField]) {
          updatedInputs[stateField] = {
            ...updatedInputs[stateField],
            value: userProfile[cookieField],
          };
        }
      });

      const newState = {
        ...prevState,
        Inputs: updatedInputs,
      };

      debuging({ section: "CookieProfile", inputs: newState.Inputs }, "SET-PROFILE-INPUTS");

      return newState;
    }, async () => {
      if (typeof callback === "function") await callback();
      resolve();
    });
  });
};

export const setDefaultSearchs = async (updateState, values = {}, callback = null) => {
    return new Promise((resolve) => {
        updateState((prevState) => {
            const { Searchs } = prevState;
            const updatedSearchs = { ...Searchs };

            Object.entries(values).forEach(([stateField, value]) => {
                if (updatedSearchs[stateField]) {
                updatedSearchs[stateField] = {
                    ...updatedSearchs[stateField],
                    value: value,
                };
                }
            });

            const newState = {
                ...prevState,
                Searchs: updatedSearchs,
            };

            debuging(
                { section: "DefaultSearchs", searchs: newState.Searchs },
                "SET-DEFAULT-SEARCHS"
            );

            return newState;
        }, async () => {
            if (typeof callback === "function") await callback();
            resolve();
        });
    });
};


/** End Set Default Profile */
export const getSomething = (setState, endpoint, filter = {}) => {
  return new Promise((resolve) => {
    requester.get(endpoint, filter)
      .then((response) => {
        // console.log("============================s", response);
        const incoming = String(response.data.incoming);
        const data = String(response?.data?.data?.data);

        if (incoming === '200') {
          resolve({ success: true, data : data });
        } else {
          resolve({ success: false, data: null });
        }
      })
      .catch((error) => {
        // console.log("============================e", error);
        if (error?.response?.status === 401) {
          setState((prevState) => {
            const newState = {
              ...prevState,
              Token: { Expired: true }
            };

            debuging(newState, "DEBUG-TOKEN-EXPIRED");
            return newState;
          });
        }

        debuging(error, 'GET-SOMETHING-FAIL');
        resolve({ success: false, data: null });
      });
  });
};



/** Set Max Sequence */
export const setMaxSequence = async (updateState, endpoint, sequenceField = 'seq', filter = []) => {
    return new Promise((resolve) => {
        let seq = null;
        let result = null;
  
        updateState(async (prevState) => {
            const { Inputs, Action } = prevState;
  
            if (Action?.Mode === 'new' && Action?.OffCanvas?.show === true) {
                result = await getMaxSequence(`${endpoint}/get-max-sequence`, { sequenceField, filter });
  
                if (result.success) {
                    let updatedInputs = { ...Inputs };
                    updatedInputs[sequenceField].value = String(result.seq);
                    seq = String(result.seq);
  
                    return { Inputs: updatedInputs };
                }
            }
            return {};
      }).then(() => {
        if (seq !== null && result?.success) {
          debuging({ sequenceField, seq, filter, result }, 'SET-MAX-SEQUENCE-BY-FILTER');
        }
        resolve(seq);
      });
    });
  };
  

  
/** Get Max Sequence - apply token expired checked */
export const getMaxSequence = async (setState, endpoint, filter) => {
    try {
      const response = await requester.put(endpoint, filter);
      const incoming = String(response.data.incoming);
      const seq = String(response?.data?.data?.sequence);
  
      if (incoming === '200') {
        return { success: true, seq };
      } else {
        return { success: false, seq: null };
      }
    } catch (error) {

        if (error?.response?.status === 401) {
            setState((prevState) => {
                const newState = {
                    ...prevState,
                    Token: { Expired: true }
                };

                debuging(newState, "DEBUG-TOKEN-EXPIRED");
                return newState;
            });
        }

        debuging(error, 'GET-MAX-SEQUENCE-FAIL');
        return { success: false, seq: null };
    }
};
  
/** Reorder - apply token expired checked */
export const reorder = async (setState, endpoint, body, loadDataTable = null) => {
    return new Promise(async (resolve) => {
      try {  
        const response = await requester.put(endpoint, body);
  
        debuging(response, "CAPTURE-RESPONSE");
  
        if (response.data.success) {
          setState((prevState) => ({
            ...prevState,
            Action: {
              ...prevState.Action,
              Toast: {
                ...prevState.Action.Toast,
                mode: 'reorder-success',
                show: true
              }
            }
          }));
  
          if (typeof loadDataTable === "function") {
            loadDataTable();
          }
  
          resolve({ success: true, message: "Reorder Successful", data: response.data });
        } else {
          setState((prevState) => ({
            ...prevState,
            Action: {
              ...prevState.Action,
              Toast: {
                ...prevState.Action.Toast,
                mode: 'reorder-fail',
                show: true
              }
            }
          }));
  
          resolve({ success: false, message: response.data.message, data: response.data });
        }
      } catch (error) {
        debuging(error, "CAPTURE-RESPONSE-ERROR");

        if (error?.response?.status === 401) {
            setState((prevState) => {
                const newState = {
                    ...prevState,
                    Token: { Expired: true }
                };
                
                debuging(newState, "DEBUG-TOKEN-EXPIRED");
                return newState;
            });

            resolve({ success: false, message: "Token expired", error });
            return;
        }        
  
        setState((prevState) => ({
          ...prevState,
          Action: {
            ...prevState.Action,
            Toast: {
              ...prevState.Action.Toast,
              mode: 'reorder-error',
              show: true
            }
          }
        }));
  
        debuging(error, 'REORDER-FAIL');
        resolve({ success: false, message: "Reorder Error", error });
      }
    });
  };
  

/** Load Masterbase - apply token expired checked */
export const loadMasterbase = async (setState, sets, freeLookup = null) => {
    return new Promise(async (resolve) => {
        try {
            const promises = sets.map(async ({ key, filter }) => {
                try {
                    let endpoint = `/api/lookup/${key}`;
                    if ( freeLookup === 'public' ) {
                        endpoint = `/public/view/NoAccessLookup/${key}`;
                    }
                    const response = await requester.post(endpoint, filter);
                    
                    debuging(response, "CAPTURE-RESPONSE");

                    return { key, data: response.data };
                } catch (error) {
                    debuging(error, "CAPTURE-RESPONSE-ERROR");
                    return { key, data: [] };
                }
            });

            const results = await Promise.all(promises);

            const updatedMasterbase = {};
            results.forEach(({ key, data }) => { 
                updatedMasterbase[key] = data?.data; 
            });

            /** load default masterbase */
            updatedMasterbase.yearBEOptions = util.getYearRangeBEObjects();
            updatedMasterbase.yearBEOptionsPrevious = util.getYearRangeBEObjectsPrevious();

            setState((prevState) => {
                return {
                    Masterbase: {
                        ...prevState.Masterbase,
                        ...updatedMasterbase
                    }
                };
            }, () => { debuging( updatedMasterbase , 'LOAD-MASTER-BASE-SUCCESS')});

            resolve({ success: true, message: "Load Masterbase Successful", data: updatedMasterbase });

        } catch (error) {

            if (error?.response?.status === 401) {
                setState((prevState) => {
                    const newState = {
                        ...prevState,
                        Token: { Expired: true }
                    };
                    
                    debuging(newState, "DEBUG-TOKEN-EXPIRED");
                    return newState;
                });

                resolve({ success: false, message: "Token expired", error });
                return;
            }  

            debuging(error, 'LOAD-MASTERBASE-FAIL');
            resolve({ success: false, message: "An unexpected error occurred", data: null });
        }
    });
};

/** Load Data Table - apply token expired checked */
export const loadDataTable = async (setState, endpoint, data = {}) => {
    return new Promise(async (resolve) => { 
        setState((prevState) => {
            const newState = {
                ...prevState,
                Action: {
                    ...prevState.Action,
                    Loading: { ...prevState.Action.Loading, dataTable: true }
                }
            };
            debuging(newState, "START-LOAD-DATA-TABLE");
            return newState;
        });

        try {
            const response = await requester.post(endpoint, data);
            debuging(response, "CAPTURE-RESPONSE");

            const success = response.data.success === true;
            const newRows = success ? response.data.data.data : [];

            const newPagination = success
                ? {
                      currentPage: response.data.data.pagination.currentPage,
                      pageSize: Number(response.data.data.pagination.pageSize),
                      sectionSize: Number(response.data.data.pagination.sectionSize),
                      totalRows: response.data.data.pagination.totalRows,
                      totalPages: response.data.data.pagination.totalPages,
                  }
                : {
                      currentPage: 1,
                      pageSize: Number(process.env.REACT_APP_PAGE_SIZE),
                      sectionSize: Number(process.env.REACT_APP_SECTION_SIZE),
                      totalRows: 0,
                      totalPages: 0
                  };

            setState((prevState) => {
                const updatedState = {
                    ...prevState,
                    Action: {
                        ...prevState.Action,
                        Loading: { ...prevState.Action.Loading, dataTable: false },
                    },
                    DataTable: {
                        ...prevState.DataTable,
                        rows: newRows,
                        pagination: {
                            ...prevState.DataTable.pagination,
                            ...newPagination,
                        },
                    },
                    Deletes: { checkAll: false, deletes: [] }
                };
        
                debuging(updatedState, success ? "END-LOAD-DATA-TABLE-SUCCESS" : "END-LOAD-DATA-TABLE-FAILED");
                return updatedState;
            });

            resolve({ success: true, message: "Load Data Table Successful",
                data: response.data
            });

        } catch (error) {
            debuging(error, "CAPTURE-RESPONSE-ERROR");

            const errorMessage = error.response?.data?.message || "Unknown error";

            // console.log("===================", error);

            if( error?.response?.status === 401 ){
                setState((prevState) => {
                    const newState = {
                        ...prevState,
                        Token: {
                            Expired: true
                        }
                    };

                    debuging(newState, "DEBUG-TOKEN-EXPIRED");
                    return newState;
                });
            }

            debuging(error, "LOAD-DATATABLE-FAIL");
            resolve({ success: false, message: errorMessage, data: null });
        }
    });
};


/** Update Something - apply token expired checked */
export const updateSomething = (setState, endpoint, element, pk, obj = {}, loadDataTable = null) => {

    return new Promise(async (resolve, reject) => {
        try {
            let data = {
                [pk.key]: pk.value,
                [obj.target.name]: obj.target.value
            };

            const response = await requester.put(endpoint, data);

            debuging(response, "CAPTURE-RESPONSE");

            if (response.data.success) {
                setState((prevState) => ({
                    ...prevState,
                    Action: {
                        ...prevState.Action,
                        Toast: {
                            ...prevState.Action.Toast,
                            mode: 'update-success',
                            show: true
                        }
                    }
                }));

                if (typeof loadDataTable === "function") {
                    loadDataTable();
                }

                resolve({ success: true, message: "Update Successful", data: response.data });
            } else {

                setState((prevState) => ({
                    ...prevState,
                    Action: {
                        ...prevState.Action,
                        Toast: {
                            ...prevState.Action.Toast,
                            mode: 'update-fail',
                            show: true
                        }
                    }
                }));

                resolve({ success: false, message: response.data.message, data: response.data });
            }
        } catch (error) {
            debuging(error, "CAPTURE-RESPONSE-ERROR");

            if( error?.response?.status === 401 ){
                setState((prevState) => {
                    const newState = {
                        ...prevState,
                        Token: {
                            Expired: true
                        }
                    };

                    debuging(newState, "DEBUG-TOKEN-EXPIRED");
                    return newState;
                });
            }            

            setState((prevState) => ({
                ...prevState,
                Action: {
                    ...prevState.Action,
                    Toast: {
                        ...prevState.Action.Toast,
                        mode: 'update-error',
                        show: true
                    }
                }
            }));

            debuging(error, "UPDATE-SOMETHING-FAIL");
            resolve({ success: false, message: "Update Error", error });
        }
    });
};

/** Fetch For Edit - apply token expired checked */
export const fetchForEdit = (setState, endpoint, obj = {}, currentInputs = null) => {
    return new Promise(async (resolve) => {
        try {
            const response = await requester.get(endpoint);
            const fetchedData = response.data.data;
    
            if (currentInputs) {

            const updatedInputs = {};
    
            for (const key in currentInputs) {
                const input = currentInputs[key];
                let value = String(fetchedData[key]);
    
                if (input?.validator?.type === 'date') {
                    value = util.convertDateToAD(value);
                } else if (input?.validator?.type === 'datetime') {
                    const datePart = util.convertDateToAD(value);
                    const timePart = value ? new Date(value).toTimeString().split(' ')[0] : '00:00:00';
                    value = `${datePart} ${timePart}`;
                }

                value = util.renderText(value);
    
                if (input?.type === 'file' && value && value !== 'null') {
                try {
                    const fileResponse = await requester.get(`${ATTACH_FILE_URL}/${value}`);
                    const fileInfo = fileResponse.data?.data;
    
                    updatedInputs[key] = {
                    ...input,
                    value: '',
                    fileId: value,
                    fileName: fileInfo?.original_name || 'ไฟล์แนบ',
                    fileInfo
                    };
                } catch (err) {
                    debuging(err, "FAILED-TO-FETCH-FILE");
                    updatedInputs[key] = { ...input, value: '', fileId: value };
                }
                } else {
                updatedInputs[key] = {
                    ...input,
                    value
                };
                }
            }
    
            setState((prevState) => ({
                ...prevState,
                Inputs: updatedInputs
            }), () => {
                handleOpenInputForm(setState, obj.element, obj.mode, obj.bool);
                resolve({ success: true, data: fetchedData });
            });
    
            } else {
            setState((prevState) => {
                const updatedInputs = Object.keys(prevState.Inputs).reduce((acc, key) => {
                const input = prevState.Inputs[key];
    
                if (fetchedData.hasOwnProperty(key)) {
                    let value = String(fetchedData[key]);
    
                    if (input?.validator?.type === 'date') {
                    value = util.convertDateToAD(value);
                    }

                    value = util.renderText(value);
    
                    acc[key] = {
                    ...input,
                    value
                    };
                } else {
                    acc[key] = input;
                }
    
                return acc;
                }, {});
    
                return {
                ...prevState,
                Inputs: updatedInputs
                };
            }, () => {
                handleOpenInputForm(setState, obj.element, obj.mode, obj.bool);
                resolve({ success: true, data: fetchedData });
            });
            }
    
        } catch (error) {
        debuging(error, "CAPTURE-RESPONSE-ERROR");
  
        if( error?.response?.status === 401 ){
            setState((prevState) => {
                const newState = {
                    ...prevState,
                    Token: {
                        Expired: true
                    }
                };

                debuging(newState, "DEBUG-TOKEN-EXPIRED");
                return newState;
            });
        }  

        setState((prevState) => ({
          ...prevState,
          Action: {
            ...prevState.Action,
            Toast: {
              ...prevState.Action.Toast,
              mode: 'fetch-edit-error',
              show: true
            }
          }
        }));
  
        debuging(error, "FETCH-FOR-EDIT-FAIL");
        resolve({ success: false, message: "Fetch Edit Error", error });
      }
    });
};
    
/** Submit Data */
export const submitData = async (setState, endpoint, mode, inputs, loadDataTable = null, setDefaultInputs = null, currentInputs = null) => {
    
    let method = mode === 'new' ? 'post' : mode === 'update' ? 'put' : mode;

    return new Promise((resolve) => {
        setState((prevState) => ({
            ...prevState,
            Action: {
                ...prevState.Action,
                Alert: {
                    ...prevState.Action.Alert,
                    mode: '',
                    show: false
                },
                Loading: {
                    ...prevState.Action.Loading,
                    submit: true
                }
            }
        }), async () => {
            try {
                let payload = {};
                let config = {};
                let hasFile = false;
                
                for (const key in inputs) {
                    const input = inputs[key];
                    if (input?.type === 'file' && input?.value instanceof File) {
                        hasFile = true;
                        break;
                    }
                }
                
                if (hasFile) {
                    const formData = new FormData();
                
                    for (const key in inputs) {
                        const input = inputs[key];
                
                        if (input?.type === 'file' && input?.value instanceof File) {
                            formData.append(key, input.value);
                        } else {
                            formData.append(key, input?.value ?? '');
                        }
                    }
                    
                    payload = formData;
                    config.headers = {
                        'Content-Type': 'multipart/form-data'
                    };
                } else {
                    for (const key in inputs) {
                        const input = inputs[key];
                        // payload[key] = input?.value ?? '';
                        payload[key] = input?.value === 'null' ? null : (input?.value ?? '');
                    }
                }
                
                const response = await requester[method](endpoint, payload, config);

                let status;
                let{ incoming, message, data } = response.data;
                incoming = String(incoming);

                debuging(response.data , "CAPTURE-RESPONSE");

                setTimeout(() => {
                    setState((prevState) => {

                        if(incoming === '200'){ status = 'success'; }
                        else {
                            if(message === 'Duplicated'){ status = '1001';}
                            else{ status = '0000'; }
                            status = constants.AppErrors.Axios[status]; 
                        }

                        return {
                            ...prevState,
                            Action: {
                                ...prevState.Action,
                                Alert: {
                                    ...prevState.Action.Alert,
                                    mode: `${mode}-${status}`,
                                    show: true
                                },
                                Loading: {
                                    ...prevState.Action.Loading,
                                    submit: false
                                }
                            },
                            Operation: {
                                ...prevState.Operation,
                                Submit: (currentInputs == null && status === 'success' && ['new', 'update'].includes(mode))
                                        ? false
                                        : (currentInputs != null && status === 'success' && mode === 'update')
                                        ? true
                                        : false
                                // (currentInputs == null && status === 'success' && mode === 'update') ? true : false
                            }
                        };
                    }, () => {
                        let id = null;

                        if (mode === 'new') {
                            id = data?.id;
                        } else if (mode === 'update' && currentInputs != null) {
                            id = currentInputs.id?.value;
                        }

                        // console.log("debuging====", mode, id, currentInputs);

                        if (incoming === '200') {
                            if (mode === 'new' && currentInputs == null) {
                                handleDiscardInputs(setState, 'Inputs');
                            }

                            if (typeof loadDataTable === "function") loadDataTable();
                            if (typeof setDefaultInputs === "function") setDefaultInputs();

                            const shouldRefetch = ['new', 'update'].includes(mode) && currentInputs != null && !util.isEmpty(id);

                            // console.log("=====================", shouldRefetch);

                            if (shouldRefetch) {
                                fetchForEdit(
                                    setState,
                                    `${endpoint}/${id}`,
                                    { element: 'OffCanvas', mode: 'update', bool: true },
                                    currentInputs
                                );
                            }
                        }
                        resolve(true);
                    });
                }, 500);
            
            }catch( error ){
                
                debuging(error, "CAPTURE-RESPONSE-ERROR");

                setState((prevState) => ({
                    ...prevState,
                    Action: {
                        ...prevState.Action,
                        Alert: {
                            ...prevState.Action.Alert,
                            mode: `${mode}-error`,
                            show: true
                        },
                        Loading: {
                            ...prevState.Action.Loading,
                            submit: false
                        },
                        Operation: {
                            ...prevState.Operation,
                            Submit: prevState.Operation.Submit
                        }
                    }
                }), () => resolve(true));
            }
        });
    });
};

export const deleteFile = async (setState, endpoint, field, obj={}) => {

    let fileId = field.value;

    let pkName = obj.id;
    let pkValue = obj.value;
    let fileField = field.key;

    let primaryKey = { key: pkName, value: pkValue };
    let updateField = { target : {name: fileField, value: null}};

    await deleteData(setState, ATTACH_FILE_URL, {deletes: [fileId]});

    await updateSomething(setState, `${endpoint}/update-something`, 'Inputs', primaryKey, updateField);

    setState((prevState) => {
        const updatedInputs = {
          ...prevState.Inputs,
          [fileField]: {
            ...prevState.Inputs[fileField],
            file: {},
            fileId: null,
            fileInfo: null,
            fileName: null
          }
        };
    
        debuging( updatedInputs, 'INPUT-FILE-RESET')
        return {
          ...prevState,
          Inputs: updatedInputs
        };
    });
}

/** Delete Data - apply token expired checked */
export const deleteData = (setState, endpoint, Deletes, loadDataTable = null) => {
    return new Promise(async (resolve) => {
        try {

            const response = await requester.delete(endpoint, { data: { deletes: Deletes.deletes } });

            debuging(response, "CAPTURE-RESPONSE");

            setState((prevState) => ({
                ...prevState,
                Action: {
                    ...prevState.Action,
                    Toast: {
                        ...prevState.Action.Toast,
                        mode: response.data.success ? 'delete-success' : 'delete-fail',
                        show: true
                    },
                    Mode: response.data.success ? prevState.Action.Mode : '',
                },
                Deletes: response.data.success ? { checkAll: false, deletes: [] } : prevState.Deletes,
                Operation: {
                    ...prevState.Operation,
                    Delete: false
                }
            }));

            if (response.data.success && typeof loadDataTable === "function") { loadDataTable(); }

            resolve({ success: response.data.success, message: response.data.message, data: response.data });
        } catch (error) {
            debuging(error, "CAPTURE-RESPONSE-ERROR");

            if( error?.response?.status === 401 ){
                setState((prevState) => {
                    const newState = {
                        ...prevState,
                        Token: {
                            Expired: true
                        }
                    };

                    debuging(newState, "DEBUG-TOKEN-EXPIRED");
                    return newState;
                });
            }      

            setState((prevState) => ({
                ...prevState,
                Action: {
                    ...prevState.Action,
                    Toast: {
                        ...prevState.Action.Toast,
                        mode: 'delete-error',
                        show: true
                    },
                    Mode: ''
                },
                Deletes: prevState.Deletes,
                Operation: {
                    ...prevState.Operation,
                    Delete: false
                }
            }));

            debuging(error, "DELETE-FAIL");
            resolve({ success: false, message: "Delete Error", error });
        }
    });
};

/** Preview File */
export const handlePreviewFile = async (updateState, data) => {
    try {
        const id = data.id;
  
        const response = await secureFetchBlob(`${ATTACH_FILE_CONTENT_URL}/${id}`);

        debuging({ response }, "CAPTURE-RESPONSE");
  
        const contentDisposition = response.headers.get("content-disposition") || "";
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=["']?([^;"'\n]*)["']?/);
        const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : "preview-file";
        
        const mimeType = response.headers.get("content-type") || "application/octet-stream";
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        
        if (!response.ok) throw new Error("Failed to fetch file preview");
  
        await updateState((prevState) => ({
            ...prevState,
            Action: {
                ...prevState.Action,
                PreviewFile: {
                    show: true,
                    data: { blobUrl, fileName, mimeType }
                }
            }
      }), () => {
        debuging({ blobUrl, fileName, mimeType }, 'MODAL-PREVIEW-FILE-OPENED');
      });
  
    } catch (error) {
        debuging(error, "CAPTURE-RESPONSE-ERROR");
  
        await updateState((prevState) => ({
            ...prevState,
            Action: {
                ...prevState.Action,
                Alert: {
                    mode: 'preview-file-error',
                    show: true
                }
            }
        }));

      debuging('File preview failed — Alert triggered', 'FETCH-FILE-FAIL');
    }
};

/** Close Preview File */
export const handleClosePreviewFile = async (updateState) => {
    await updateState((prevState) => ({
      ...prevState,
      Action: {
        ...prevState.Action,
        PreviewFile: {
          show: false,
          data: null
        }
      }
    }));
  
    debuging('Preview modal closed', 'CLOSE-FILE-PREVIEW');
};

export const loadImageBlobUrls = async ({ rows = [], fileField = "", idField = "", baseUrl = "" }) => {
    const imageUrls = {};

    for (const row of rows) {
        const fileId = row[fileField];
        const id = row[idField];

        if (fileId) {
            const url = `${baseUrl}/${fileId}`;
            try {
                const blobUrl = await secureFetchImageBlobUrl(url);
                imageUrls[id] = blobUrl;
            } catch (error) {
                console.warn(`Failed to load image for ID ${id}:`, error);
                imageUrls[id] = null;
            }
        }
    }
    return imageUrls; 
};

/** Load Data Sets - apply token expired checked */
export const loadDatasets = async (setState, sets) => {
    return new Promise(async (resolve) => {
        try {
            const promises = sets.map(async ({ key, filter }) => {
                try {
                    const endpoint = `/api/lookup/${key}`;
                    const response = await requester.post(endpoint, filter);
                    
                    debuging(response, "CAPTURE-RESPONSE");

                    return { key, data: response.data };
                } catch (error) {
                    debuging(error, "CAPTURE-RESPONSE-ERROR");
                    return { key, data: [] };
                }
            });

            const results = await Promise.all(promises);

            const updatedDatasets = {};
            results.forEach(({ key, data }) => { 
                updatedDatasets[key] = data?.data; 
            });

            setState((prevState) => {
                return {
                    Datasets: {
                        ...prevState.Datasets,
                        ...updatedDatasets
                    }
                };
            }, () => { debuging( updatedDatasets , 'LOAD-DATASETS-SUCCESS')});

            resolve({ success: true, message: "Load Datasets Successful", data: updatedDatasets });

        } catch (error) {

            if( error?.response?.status === 401 ){
                setState((prevState) => {
                    const newState = {
                        ...prevState,
                        Token: {
                            Expired: true
                        }
                    };

                    debuging(newState, "DEBUG-TOKEN-EXPIRED");
                    return newState;
                });
            } 

            // console.error("Unexpected error in Load Datasets:", error);
            debuging(error, "LOAD-DATASETS-FAIL");            
            resolve({ success: false, message: "An unexpected error occurred", data: null });
        }
    });
};

export const handlePrintEBPopup = (path, current, buttonlabel = '') => {
    let url = `/apps/${path}/${current}` + (buttonlabel ? `/${buttonlabel}` : '');
    const features = 'width=900,height=700,scrollbars=yes,resizable=yes';
    window.open(url, '_blank', features);
};

export const handlePreviewPub = (type, id, buttonlabel = '') => {
    console.log("type,id",type,id);
    
    let url = `/publicize/` + (type && id ? `news/${type}/${id}/preview` : '');
    const features = 'width=900,height=700,scrollbars=yes,resizable=yes';
    window.open(url, '', features);
};

/** Debuging */
const debuging = (state, actionName, details) => {
    if(DEBUG){
        if (details !== undefined) {
            console.log(`🚀 [DEBUG] ${actionName}`, state, details);
        } else {
            console.log(`🚀 [DEBUG] ${actionName}`, state);
        }
    }
};
